import { useContext } from 'react';

import NewClubRegistrationData from './NewClubRegistrationData';

import { ClubRegistrationNewStateContext } from '../../clubRegistrationNew/ClubRegistrationNewContextProvider';

const useNewClubRegistrationData = () => {
  const [clubRegistrationState, setClubRegistrationState] = useContext(ClubRegistrationNewStateContext);

  const getUsasClub = (usasClubId) => {
    return NewClubRegistrationData.getUsasClub(usasClubId, clubRegistrationState, setClubRegistrationState);    
  };

  const postNewClubRegistration = (clubObj) => {
    return NewClubRegistrationData.postNewClubRegistrationData(clubObj, clubRegistrationState, setClubRegistrationState);
  };

  const putNewClubRegistration = (usasClubId, clubObj) => {
    return NewClubRegistrationData.putNewClubRegistrationData(usasClubId, clubObj, clubRegistrationState, setClubRegistrationState);
  };

  return {
    clubRegistrationState,
    setClubRegistrationState,
    getUsasClub,
    postNewClubRegistration,
    putNewClubRegistration
  };
};

export default useNewClubRegistrationData;